<template>
    <Modal v-model="show" title="总监部门成员信息" :width="60">
        <Spin v-if="$globalSpin" size="large" fix></Spin>
        <Form
            ref="modelForm"
            :model="modelForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form"
        >
            <Row :gutter="16">
                <Col span="24">
                    <FormItem label="说明">
                        <span
                            >填写公司名称(新增公司或者新增公司与苗场的关联关系)：公司名称手动填写，部门下拉框会显示所有苗场，联动显示成员</span
                        >
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <FormItem label="公司名称" prop="projectCompany">
                        <Input v-model="modelForm.projectCompany"></Input>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择部门" prop="seedFarmUuid">
                        <Select
                            v-model="modelForm.seedFarmUuid"
                            @on-change="onSeedFarmChange"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in deptList"
                                :key="item.seedFarmUuid"
                                :value="item.seedFarmUuid"
                                :label="
                                    item.seedFarmCode + '~' + item.seedFarmName
                                "
                            >
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择成员" prop="projectCode">
                        <Select
                            v-model="modelForm.projectCode"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in memberList"
                                :key="item.userName"
                                :value="item.userName"
                                :label="item.userPersonName"
                            >
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary" @click="onSave">确认</Button>
            <Button type="error" @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";

import {
    getInspectorCompanyList,
    getInspectorDeptList,
    getInspectorMemberList,
    addProject
} from "@/api/modules/account-management/inspector-user-management";

export default {
    name: "RoleDeptInspectorEditWriteCompany",
    data() {
        return {
            show: false,
            uuid: "",
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            modelForm: {
                projectCode: "",
                seedFarmUuid: "",
                projectUuid: "",
                projectName: "",
                projectCompany: "",
                projectType: "",
                belongTo: "总监"
            },
            ruleValidate: {
                projectCompany: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ],
                seedFarmUuid: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ],
                projectCode: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ]
            },
            companyList: [],
            deptList: [],
            memberList: []
        };
    },
    mounted() {},
    methods: {
        showModal(uuid) {
            if (uuid == "") {
                this.uuid = "";
                this.formEditMode = FORM_EDIT_MODE_CREATE;
            }
            else {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.uuid = uuid;
            }
            this.init();
            this.show = true;
        },
        init() {
            this.getInspectorDeptList();
            this.$refs.modelForm.resetFields();
        },
        getInspectorDeptList() {
            this.$showGlobalSpin();
            getInspectorDeptList({
                showAll: 1
            }).then((res) => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.deptList = res.data.records;
                }
            });
        },
        onSeedFarmChange() {
            if (this.modelForm.seedFarmUuid) {
                getInspectorMemberList({
                    seedFarmUuid: this.modelForm.seedFarmUuid
                }).then((res) => {
                    if (res.code === 0) {
                        this.memberList = res.data.records;
                    }
                });
            }
            else {
                this.memberList = [];
            }
        },
        onSave() {
            this.$refs.modelForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }
                const data = Object.assign(
                    {
                        formEditMode: this.formEditMode
                    },
                    this.modelForm
                );

                this.$showGlobalSpin();
                addProject(data).then((res) => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.show = false;
                                this.$refs.modelForm.resetFields();
                                this.$parent.getTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            this.$refs.modelForm.resetFields();
        }
    }
};
</script>

<style scoped></style>
